import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

export default function initSliders() {

  const swiper = new Swiper('.swiper--with-arrows', {
    modules: [Navigation, A11y],
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 1,
    spaceBetween: 25,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 4
      },
    },
  });

  const swiper2 = new Swiper('.swiper--with-dots', {
    modules: [Pagination, A11y],
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
  });
}
